import axios from "axios";
import { Base_URL } from "../url";

export const fetchResources = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters/${id}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

export const downloadResourceMasterExcel = async (filters) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SalaryProcess/DownloadResourceMasterExcel`,
      filters,

      {
        responseType: "blob", // important for file downloads
      },
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading resource data!";
  }
};

/**
 * Get Resource details by Mav_UserID
 */
export const getResourceByMavUserId = async (mavUserId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Resource/GetResourceByMavUserId/${mavUserId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource by Mav_UserID!";
  }
};

export const getResourcesByOrgId = async (orgId) => {
  const res = await axios.get(`${Base_URL}/Resource/GetByOrg/${orgId}`);
  return res.data;
};
